import { z } from 'zod';

export const MAX_CLASS_CANCELLATION_MINUTES = 43_200;
export const ClassPolicySchema = z.object({
  cancellationCutoffMin: z.number().int().min(0).max(MAX_CLASS_CANCELLATION_MINUTES),
  paymentMode: z.enum(['pay_at_studio', 'prepay_required']),
}).strict();
export const LEGACY_CLASS_POLICY = { cancellationCutoffMin: 0, paymentMode: 'pay_at_studio' as const };
export const BookingPaymentChoiceSchema = z.enum(['pay_at_studio', 'pack_credit', 'yappy', 'paguelofacil']);
export const BookingReviewRequestSchema = z.object({ paymentChoice: BookingPaymentChoiceSchema }).strict();
export const BookingConfirmRequestSchema = z.object({ reviewId: z.string().uuid().optional() }).strict();
export type ClassPolicy = z.infer<typeof ClassPolicySchema>;
export type BookingPaymentChoice = z.infer<typeof BookingPaymentChoiceSchema>;
